import { BoxStaffAddForm } from "@modules/boxStaff/components/boxStaffAddForm"
import { BoxStaffCardsView } from "@modules/boxStaff/components/boxStaffCardsView"
import { BoxStaffDetailsInfo } from "@modules/boxStaff/components/boxStaffDetailsInfo"
import { BoxStaffDetailsPending } from "@modules/boxStaff/components/boxStaffDetailsPending"
import { BoxStaffPermissions, BoxStaffRole } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"

export const useBoxStaffSidebar = () => {
  const { sidebarNavigateTo, hideSidebar } = useSidebar()
  const canAddStaff = useBoxStaffPermission(BoxStaffPermissions.ADD_STAFF)

  const navigateToBoxStaffCards = (selectedRole?: BoxStaffRole) =>
    sidebarNavigateTo({
      content: <BoxStaffCardsView selectedRole={selectedRole} />,
      replaceAllComponents: true,
    })

  const navigateToStaffDetailsInfo = (staffId: string, args: SidebarNavigatorParams) => {
    sidebarNavigateTo({
      content: <BoxStaffDetailsInfo staffId={staffId} />,
      ...args,
    })
  }

  const navigateToStaffDetailsPending = (staffId: string, args: SidebarNavigatorParams) => {
    sidebarNavigateTo({
      content: <BoxStaffDetailsPending staffId={staffId} />,
      ...args,
    })
  }

  const navigateToAddBoxStaffForm = (boxStaffRole: BoxStaffRole) => {
    // PERMISSIONS - Head-coach && Coach & Financial permissions denied
    if (!canAddStaff) {
      return null
    }

    sidebarNavigateTo({
      content: <BoxStaffAddForm boxStaffRole={boxStaffRole} />,
      replaceAllComponents: true,
    })
  }

  return {
    navigateToBoxStaffCards,
    navigateToStaffDetailsInfo,
    navigateToStaffDetailsPending,
    hideSidebar,
    navigateToAddBoxStaffForm,
  }
}
